<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>人物管理 > <b>灵动人物列表</b></BreadcrumbItem>
      </Breadcrumb>
      <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
        <span class="search_span_width" style="margin-right: 10px;">
	  				<span class="search_span_width_part1">用户ID：</span>
	  				<Input v-model="search.user_id"  style="width: 100px" />
        </span>
        <span class="search_span_width">
	  				<span class="search_span_width_part1">生成状态：</span>
	  				<Select v-model="search.job_status" clearable  style="width:120px" >
	  					<Option value="8">图片待生成</Option>
	  					<Option value="1">图片生成中</Option>
	  					<Option value="2">图片生成成功</Option>
	  					<Option value="3">图片生成失败</Option>
	  					<Option value="4">视频待生成</Option>
	  					<Option value="5">视频生成中</Option>
	  					<Option value="6">视频生成成功</Option>
	  					<Option value="7">视频生成失败</Option>
	  				</Select>
        </span>
        <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getSettingList(1)">搜索</Button>
      </Card>
      <Card id="tableContent" >
        <Table :columns="tableColumns" :data="setting_list"></Table>
        <Page :total="total" :current="search.page" :page-size=search.pagesize :show-elevator="true" @on-change="getSettingList"/>
      </Card>
    </Content>
  </Layout>
</template>
<script>
export default {
  data(){
    return {
      search:{
        page:1,
        pageSize: 10,
        user_id:"",
        job_status:""
      },
      total:0,
      showmodal:false,
      showinfomodal:false,
      showAddModal: false,
      jsons:{},
      setting_list:[],
      setting:{
        id:0,
        set_val:'',
        set_key_name:''
      },
      addSetting:{
        set_key: '',
        set_key_name: '',
        set_val: '',
        is_use: '1'
      },
      tableColumns:[
        { title: 'ID', key: 'id',fixed:"left", align: 'center', width:100 },
        { title: '用户ID', key: 'user_id',fixed:"left", align: 'center', width:100 },
        { title: '视频标题', key: 'video_title',fixed:"left", align: 'center', width:100 },
        { title: '预览图', key: 'preview_img', align: 'center',width:200 ,render:(h,params) =>{
            return h('img',{
              attrs : {src : params.row.preview_img},
              style : { width : '80px' }
            })
          }
        },
        { title: '数字人ID', key: 'figure_id', align: 'center',width:100  },
        { title: '视频类型', key: 'video_type', align: 'center',width:100, render: (h,params)=>{
            if(params.row.video_type==0){
              return h('span',{},"用户视频");
            }
            if(params.row.video_type==1){
              return h('span',{},"模板视频");
            }
            if(params.row.video_type==2){
              return h('span',{},"人像绘制");
            }
            if(params.row.video_type==3){
              return h('span',{},"文生图");
            }
            if(params.row.video_type==4){
              return h('span',{},"图生视频");
            }
            return h('span',{},"未知类型");
          }
        },
        { title: '发音人ID', key: 'spk_id',width:100, align: 'center' },
        { title: '生成状态', key: 'job_status',width:150, align: 'center',render: (h,params)=>{
            if(params.row.job_status==1){
              return h('span',{},"图片生成中");
            }
            if(params.row.job_status==2){
              return h('span',{},"图片生成成功");
            }
            if(params.row.job_status==3){
              return h('span',{},"图片生成失败");
            }
            if(params.row.job_status==4){
              return h('span',{},"视频待生成");
            }
            if(params.row.job_status==5){
              return h('span',{},"视频生成中");
            }
            if(params.row.job_status==6){
              return h('span',{},"视频生成成功");
            }
            if(params.row.job_status==7){
              return h('span',{},"视频生成失败");
            }
            return h('span',{},"图片待生成");
          }
        },
        { title: '时长(毫秒)', key: 'video_millisecond',width:120, align: 'center' },
        { title: '描述', key: 'video_desc', align: 'center',width:300 },
        {
          title: '是否上架', key: 'status', align: 'center',width:100, render: (h, params) => {
            if (params.row.status == 1) {
              return h('span', {}, "上架");
            }
            if (params.row.status == 2) {
              return h('span', {}, "下架");
            }
            return h('span', {}, "");
          },
        },
        { title: '创建时间', key: 'created_at',width:200, align: 'center' },

      ]
    }
  },
  mounted:function(){
    this.getSettingList();
  },
  computed:{

  },
  methods:{
    getSettingList(page) {
      if(page){
        this.search.page = page
      }
      this.http.get('/admin/figure/getAiVideoList',{params:this.search}).then(response=>{
        let data=response.data;
        if(data.code!==0){
          alert(data.message);
        } else{
          this.setting_list = data.data.list;
          this.total = data.data.total

        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
    clearSetting(set_key){
      this.http.post('/admin/common/clearSetting',{
        set_key:set_key
      }).then(response=>{
        let data=response.data;
        if(data.code!==0) {
          this.$Message.error(data.message);
          return false;
        } else{
          this.$Message.info(data.message);
          return true;
        }
      });
    },
    addSettingModal() {
      this.addSetting.set_key = '';
      this.addSetting.set_key_name = '';
      this.addSetting.set_val = '';
      this.addSetting.is_use = '1';
      this.showAddModal = true;
    },
    createSetting(){
      if (this.isJSON(this.addSetting.set_val) == false) {
        this.$Message.error('值JSON格式错误');
        return false;
      }
      if(!this.addSetting.set_key_name){
        this.$Message.error('缺少名称');
        return false;
      }
      if(!this.addSetting.set_key){
        this.$Message.error('缺少键');
        return false;
      }
      this.http.post('/admin/common/createSetting',this.addSetting).then(response=>{
        let data=response.data;
        if(data.code!==0) {
          this.$Message.error(data.message);
          return false;
        } else{
          this.$Message.info(data.message);
          this.showAddModal = false;
          this.getSettingList();
          return true;
        }
      });

    },
    saveSetting(){
      this.http.post('/admin/common/saveSetting',this.setting).then(response=>{
        let data=response.data;
        if(data.code!==0) {
          this.$Message.error(data.message);
          return false;
        } else{
          this.$Message.info(data.message);
          this.showmodal = false;
          this.getSettingList();
          return true;
        }
      });
    },
    closeModal(){
      this.setting.id = 0;
      this.setting.set_val = '';
      this.showmodal=false;
    }
  }

}
</script>
